export default __webpack_public_path__ + "assets/models/c6cd78093d669d64c4e70da2e9b64f11.glb";